import { Typography } from '@mui/material'

import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import {
  SMSVerificationForm,
  SMSVerificationFormProps,
} from './SMSVerificationForm'

export * from './fragments'

export type State = {
  phoneNumber: string | null
  loading: boolean
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: SMSVerificationFormProps['onSubmit']
  onResend: SMSVerificationFormProps['onResend']
}

export const SMSVerificationTemplate: Template<State, Action> = ({
  state,
  onSubmit,
  onResend,
}) => {
  const { t } = useTranslation('smsVerification')
  const { routerNames } = useRouter()
  return (
    <>
      <Head title={routerNames.SMSVerification} />
      <BaseLayout margin header={{ back: true, title: t('title') }}>
        <Typography variant="body2" sx={{ pt: 2 }}>
          {t('description', { phoneNumber: state.phoneNumber })}
        </Typography>
        <SMSVerificationForm
          loading={state.loading}
          onSubmit={onSubmit}
          onResend={onResend}
        />
      </BaseLayout>
    </>
  )
}
